export const USER_PROFILE_KEY = ["userProfile"];
export const TODOS_KEY = ["todos"];
export const USER_SIGNATURES_KEY = ["userSignatures"];
